<template>
  <section
    class="relative flex flex-col max-w-6xl mx-auto md:flex-row min-h-[500px] items-center justify-between bg-[#F8F8F8] py-16 px-6 md:px-20 overflow-hidden gap-12 md:gap-20"
  >
    <!-- Texto a la izquierda -->
    <div
      class="flex flex-col justify-center text-center md:text-left text-[#030515] max-w-2xl z-10 h-full md:whitespace-pre-line"
    >
      <p class="text-sm font-bold mb-2 tracking-wide">
        {{ $t('about.label') }}
      </p>
      <h2 class="text-2xl md:text-3xl font-semibold leading-snug mb-6">
        {{ $t('about.title') }}<br />{{ $t('about.titleContinue') }}
      </h2>
      <p class="text-base md:text-lg md:mb-8 leading-relaxed">
        {{ $t('about.description') }}<br />{{ $t('about.descriptionContinue1') }}
      </p>
    </div>

    <!-- Imagen decorativa a la derecha -->
    <div class="relative -mt-4 md:-mt-12 w-64 md:w-72 h-64 lg:w-80 transition-all duration-500">
      <transition name="fade">
        <img
          :key="currentImage"
          :src="images[currentImage]"
          alt="Acerca de INBROS"
          class="absolute inset-0 w-full h-full object-cover rounded-[2.5rem] shadow-lg"
        />
      </transition>
      <!-- Indicadores opcionales (puntos) -->
      <div class="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2 z-10">
        <button
          v-for="(image, index) in images"
          :key="index"
          @click="goToImage(index)"
          :class="[
            'w-2 h-2 rounded-full transition-all duration-300',
            currentImage === index ? 'bg-[#030515] w-6' : 'bg-[#030515]/30 hover:bg-[#030515]/50'
          ]"
          :aria-label="`Ver imagen ${index + 1}`"
        />
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

// Importa imágenes
import about from '../assets/about.png'
import vida from '../assets/vida.png'
import ahorro from '../assets/ahorro.png'
import auto from '../assets/auto.png'
import especiales from '../assets/Especiales.png'
import hogar from '../assets/hogar.png'
import viaje from '../assets/viaje2.png'

const images = [about, vida, ahorro, auto, especiales, hogar, viaje]
const currentImage = ref(0)

let interval = null

// Iniciar el carrusel automático
const startInterval = () => {
  interval = setInterval(() => {
    currentImage.value = (currentImage.value + 1) % images.length
  }, 4000) // 4 segundos
}

// Función para cambiar a una imagen específica (al hacer clic en indicadores)
const goToImage = (index) => {
  currentImage.value = index
  // Reiniciar el intervalo para evitar cambios bruscos
  resetInterval()
}

// Reiniciar el intervalo (útil cuando el usuario interactúa)
const resetInterval = () => {
  if (interval) {
    clearInterval(interval)
  }
  startInterval()
}

onMounted(() => {
  startInterval()
})

onUnmounted(() => {
  if (interval) {
    clearInterval(interval)
  }
})
</script>

<style scoped>
/* Transición suave entre imágenes */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s ease;
  position: absolute;
}

.fade-enter-from {
  opacity: 0;
}

.fade-leave-to {
  opacity: 0;
}

.relative {
  overflow: hidden;
}
</style>
